var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import { UrlHelper } from '../../../helper/UrlWrapper';
var ImportData = (function (_super) {
    __extends(ImportData, _super);
    function ImportData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.resetUploadUrl = '';
        _this.dialogAuditImportVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.beforeImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = '';
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = '';
        _this.UrlString = "";
        return _this;
    }
    ImportData.prototype.watchUploadUrl = function (newValue, oldValue) {
        this.resetUploadUrl = "" + newValue + (newValue.indexOf("?") === -1 ? '?' : '&') + "token=" + this.user.token;
        console.log(this.resetUploadUrl);
    };
    ImportData.prototype.showImportModal = function () {
        var order_type_string;
        if (this.formData['order_mode'] === 0) {
            order_type_string = "order_type=" + this.formData['order_type'];
        }
        else {
            order_type_string = "stock_type=1";
        }
        this.UrlString = "organ_name=" + this.ImportTitle['organ_name'] + "&depot_name=" + this.ImportTitle['depot_name'] + "&order_type_name=" + this.ImportTitle['order_type_name'] + "&stock_type_name=" + this.ImportTitle['stock_type_name'] + "&depot_id=" + this.formData['depot_id'] + "&limit=0&" + order_type_string;
        this.resetUploadUrl = this.uploadUrl + "?token=" + this.user.token + "&depot_id=" + this.formData['depot_id'] + "&limit=0&" + order_type_string;
        this.dialogAuditImportVisible = true;
        this.setUploadType('before');
    };
    ImportData.prototype.setUploadType = function (type) {
        this.beforeImport = type == 'before';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    ImportData.prototype.beforeUpload = function (file) {
        var name = file.name.split('.'), fileType = name[name.length - 1];
        if (!(fileType && (fileType == 'xlsx' || fileType == 'xls' || fileType == 'csv'))) {
            this.$message.error('文件只能是xlsx或xls');
            return false;
        }
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    ImportData.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = this.uploadErrorUrl + "?import_id=" + data.import_id + "&type=" + data.type;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.$emit('updateData', data.success_import);
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || '网络异常，请重新导入';
            this.$message.error(this.errorMsg);
        }
        this.uploadEnd(response);
    };
    ImportData.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || '网络异常，请重新导入';
        this.uploadEnd();
    };
    ImportData.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = '';
            this.setUploadType('before');
        }
        else {
            this.setUploadType('after');
        }
        this.loadingInstance.close();
    };
    ImportData.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType('importing');
    };
    __decorate([
        Prop({
            type: String,
            default: '导入数据'
        })
    ], ImportData.prototype, "importModalTitle", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], ImportData.prototype, "fileTemplateUrl", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], ImportData.prototype, "uploadUrl", void 0);
    __decorate([
        Prop({
            type: String,
            default: '/basicapi/export_error'
        })
    ], ImportData.prototype, "uploadErrorUrl", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ImportData.prototype, "descriptionCustom", void 0);
    __decorate([
        Prop({
            type: Object,
        })
    ], ImportData.prototype, "formData", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], ImportData.prototype, "ImportTitle", void 0);
    __decorate([
        Watch('uploadUrl', { immediate: true })
    ], ImportData.prototype, "watchUploadUrl", null);
    ImportData = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user'
            }))
        })
    ], ImportData);
    return ImportData;
}(Vue));
export default ImportData;
